/**
 * Single word - not EXAM_ONE or examOne, consistent with CARESEND = 'caresend'
 *  (our existing implementation has inconsistencies)
 */
export var FulfillmentIntegrationName;
(function (FulfillmentIntegrationName) {
    FulfillmentIntegrationName["EXAMONE"] = "examOne";
})(FulfillmentIntegrationName || (FulfillmentIntegrationName = {}));
export var FulfillmentIntegrationType;
(function (FulfillmentIntegrationType) {
    FulfillmentIntegrationType["LAB"] = "lab";
    FulfillmentIntegrationType["MOBILE"] = "mobile";
})(FulfillmentIntegrationType || (FulfillmentIntegrationType = {}));
//# sourceMappingURL=fulfillmentIntegration.js.map